import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function SolutionReveal() {
  const benefits = ['Aguantar sin colapsar', 'Reducir el daño', 'Poner límites discretos', 'Abrir una ruta de salida sin caos'];
  return <Section variant="dark" className="text-center" data-id="element-115">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-116">
        <p className="text-red-500 font-bold tracking-widest uppercase mb-4" data-id="element-117">
          La Solución
        </p>
        <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tighter mb-8 leading-none" data-id="element-118">
          Plan de Supervivencia
          <br data-id="element-119" />
          <span className="text-neutral-500" data-id="element-120">30 Días</span>
        </h2>

        <div className="relative mx-auto w-64 md:w-80 mb-10" data-id="element-121">
          <div className="absolute inset-0 bg-red-600 blur-[60px] opacity-20 rounded-full" data-id="element-122"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iedMqhHY8M1TZM68mwJeyn/planm_de_sa.png" alt="No Puedo Renunciar PDF" className="relative z-10 rounded-lg shadow-2xl border border-neutral-800" data-id="element-123" />
        </div>

        <div className="max-w-xl mx-auto text-left bg-neutral-900/50 p-6 rounded-xl border border-neutral-800/50" data-id="element-124">
          <p className="text-white font-medium mb-4" data-id="element-125">
            Un sistema paso a paso para:
          </p>
          <ul className="space-y-3 mb-6" data-id="element-126">
            {benefits.map((benefit, i) => <li key={i} className="flex items-center text-neutral-300" data-id="element-127">
                <Check className="text-red-500 mr-3 h-5 w-5 flex-shrink-0" data-id="element-128" />
                {benefit}
              </li>)}
          </ul>

          <div className="pt-6 border-t border-neutral-800" data-id="element-129">
            <p className="text-neutral-400 mb-2" data-id="element-130">
              No te promete “trabajar desde la playa”.
            </p>
            <p className="text-white font-bold text-lg" data-id="element-131">
              Te promete algo más raro y más valioso cuando estás al límite:
              <br data-id="element-132" />
              <span className="text-red-500 text-2xl block mt-2" data-id="element-133">
                Volver a respirar.
              </span>
            </p>
          </div>
        </div>
      </motion.div>
    </Section>;
}